import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Table, Button, Modal, Alert, Grid, Row, Col } from 'antd';
import moment from 'moment';
import { downloadFile } from '../../../common/downloadReportFunc';
import { useFetchAuditTrailLogs } from './redux/hooks';
import { useFetchManageOutsStateCompare } from './redux/hooks';
import { DATE_TIME_ONE_FORMAT } from '../../../common/constants';
import './ManageOutsAuditTrailLogs.less';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import { useExportManageOutsHistoryTrack } from './redux/hooks';

export default function ManageOutsAuditTrailLogs(props) {
  const { selectedOrder, fetchAuditLogError } = props;
  const { exportHistoryTrack, exportHistoryTrackPending } = useExportManageOutsHistoryTrack();
  const { auditLogData, auditLogTotal, fetchAuditLogPending } = useSelector(state => ({
    auditLogData: state.manageOutsAuditTrail.auditLogData,
    auditLogTotal: state.manageOutsAuditTrail.auditLogTotal,
    fetchAuditLogPending: state.manageOutsAuditTrail.fetchAuditLogPending,
  }));

  const { fetchAuditTrailLogs } = useFetchAuditTrailLogs();
  const { fetchManageOutsStateCompare } = useFetchManageOutsStateCompare();

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md; // true when viewport is small (mobile)

  //const [pagination, setPagination] = useState({ current: 1, pageSize: 5, total: 0 });
  const DEFAULT_PAGE_SIZE = 5;
  const [pagination, setPagination] = useState({ current: 1, pageSize: DEFAULT_PAGE_SIZE, total: 0 });

  //View Details
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [detailError, setDetailError] = useState(null);
  const [answerKeyVisible, setAnswerKeyVisible] = useState(false);
  const helpHeaderStyle = {
    fontWeight: 600,
    fontSize: 12,
    color: '#333',
    marginBottom: 14,
  };

  const helpCodeStyle = {
    color: '#1890ff',
    fontWeight: 600,
    fontSize: 11,
    marginRight: 0,
  };

  const helpTextStyle = {
    color: '#333',
    fontSize: 11,
    marginRight: 6,
  };

  const renderAnswerKey = () => (
  <div style={{ paddingTop: 4 }}>
    <Row>
      <Col span={24} style={helpHeaderStyle}>
        Order Type
        <div>
          <span style={helpCodeStyle}>REG</span>
          <span style={helpTextStyle}>-Regular</span>
        </div>
      </Col>
    </Row>

    <Row>
      <Col span={24} style={helpHeaderStyle}>
        Order Status Code - Header
        <div>
          <span style={helpCodeStyle}>O</span>
          <span style={helpTextStyle}>-Open,</span>
          <span style={helpCodeStyle}>D</span>
          <span style={helpTextStyle}>-Sent For Routing</span>
        </div>
      </Col>
    </Row>

    <Row>
      <Col span={24} style={helpHeaderStyle}>
        Stock Type
        <div>
          <span style={helpCodeStyle}>S</span>
          <span style={helpTextStyle}>-Stocked</span>
        </div>
      </Col>
    </Row>

    <Row>
      <Col span={24} style={helpHeaderStyle}>
        Order Reason Code Details
        <div>
          <span style={helpCodeStyle}>OUT</span>
          <span style={helpTextStyle}>-Out of Stock,</span>
          <span style={helpCodeStyle}>OFO</span>
          <span style={helpTextStyle}>-Out Due to Future Order,</span>
          <span style={helpCodeStyle}>RST</span>
          <span style={helpTextStyle}>-Cannot Buy,</span>
          <span style={helpCodeStyle}>IAJ</span>
          <span style={helpTextStyle}>-Inventory Adjustment,</span>
          <span style={helpCodeStyle}>AOS</span>
          <span style={helpTextStyle}>-Address Out Of Stock</span>
        </div>
      </Col>
    </Row>

    <Row>
      <Col span={24} style={helpHeaderStyle}>
        Drop Flag
        <div>
          <span style={helpCodeStyle}>Y</span>
          <span style={helpTextStyle}>-Yes,</span>
          <span style={helpCodeStyle}>N</span>
          <span style={helpTextStyle}>-No,</span>
          <span style={helpCodeStyle}>Empty</span>
          <span style={helpTextStyle}>-No value in DB for drpflag column,</span>
          <span style={helpCodeStyle}>Null</span>
          <span style={helpTextStyle}>-Null value in DB for drpflag column</span>
        </div>
      </Col>
    </Row>

    <Row>
      <Col span={24} style={helpHeaderStyle}>
        Order Detail Changes
        <div style={{ fontWeight: 400, fontSize: 11, color: '#333' }}>
          Order detail allocated = Item is added to an order
        </div>
        <div style={{ fontWeight: 400, fontSize: 11, color: '#333' }}>
          Order line item deallocated = Item is removed from order
        </div>
      </Col>
    </Row>
  </div>
);

  const handleViewDetails = async (record, rowIndex) => {
    setDetailError(null);
    setDetailLoading(true);

    const payload = {
      conceptId: record.conceptId || (selectedOrder && selectedOrder.conceptId) || '',
      customerShipTo: record.customerShipTo || record.customerNumber || (selectedOrder && selectedOrder.customerShipTo) || '',
      deliveryDate: record.deliveryDate || (selectedOrder && selectedOrder.deliveryDate) || '',
      itemNumber: record.itemNumber || (selectedOrder && (selectedOrder.originalItem || selectedOrder.itemNumber)) || '',
      orderNumber: record.orderNumber || (selectedOrder && (selectedOrder.orderNumber || selectedOrder.orderNo)) || '',
      site: record.site || (selectedOrder && (selectedOrder.site || selectedOrder.opco)) || '',
    };

    try {
      const data = await fetchManageOutsStateCompare(payload);
      if (!data || data.length === 0) {
        throw new Error('No details returned');
      }

      const totalRows = pagination.total || 0;
      const pageSize = pagination.pageSize || 1;
      const lastPageIndex = Math.max(1, Math.ceil(totalRows / pageSize));
      const isFirst = pagination.current === 1 && rowIndex === 0;
      const isLast = pagination.current === lastPageIndex && rowIndex === ((auditLogData || []).length - 1);

      const entry = data[0] || {};
      let detailsToShow;
      if (isFirst && entry.currentValue) {
        detailsToShow = { which: 'currentValue', value: entry.currentValue };
      } else if (isLast && entry.initialValue) {
        detailsToShow = { which: 'initialValue', value: entry.initialValue };
      } else {
        detailsToShow = { which: 'both', value: { initialValue: entry.initialValue, currentValue: entry.currentValue } };
      }

      setSelectedLog(detailsToShow);
      setDetailModalVisible(true);
    } catch (err) {
      setDetailError(err && err.message ? err.message : 'Failed to load details');
      setSelectedLog(null);
      setDetailModalVisible(true);
    } finally {
      setDetailLoading(false);
    }
  };

  const fieldLabels = {
    dropFlag: 'Drop Flag',
    // orderType: 'Order Type',
    // orderDetailAllocated: 'Order Detail Allocated',
    orderReasonCode: 'Order Reason Code',
    // substituteReferenceLineNbr: 'Substitute Reference Line #', //Remove if not required by Client
    orderHeaderStatusCode: 'Order Header Status',
    orderDetailStatusCode: 'Order Detail Status',
    stockType: 'Stock Type',
    demandStatus: 'Demand Status',
    quantity: 'Quantity Ordered', 
    quantityAllocAgainstOnHand: 'Quantity Alloc Against On Hand',
  };

  const renderObjectFields = (obj = {}) => {
    return Object.keys(fieldLabels).map(key => {
      const val = obj && Object.prototype.hasOwnProperty.call(obj, key) ? obj[key] : '';
      return (
        <div key={key} style={{ marginBottom: 6 }}>
          <strong style={{ minWidth: 200, display: 'inline-block' }}>{fieldLabels[key]}:</strong>
          <span>{val !== null && val !== undefined ? String(val) : ''}</span>
        </div>
      );
    });
  };

  //View Details

  const formatDateArg = (d) => {
    if (!d) return '';
    const s = String(d);
    // if already YYYYMMDD (8 digits) return as-is, otherwise format with moment
    return /^\d{8}$/.test(s) ? s : moment(d).format('YYYYMMDD');
  };

  useEffect(() => {
    setPagination(prev => ({ ...prev, total: auditLogTotal || 0 }));
  }, [auditLogTotal]);

  useEffect(() => {
    if (!selectedOrder) return;
    setPagination(prev => ({
      ...prev,
      current: 1,
      pageSize: DEFAULT_PAGE_SIZE,
    }));
  }, [selectedOrder]);

  const exportAuditReports = () => {
    if (!selectedOrder) return;
    const payload = {
      conceptId: selectedOrder.conceptId || '',
      customerShipTo: selectedOrder.customerShipTo || selectedOrder.customerNumber || '',
      deliveryDateFrom: formatDateArg(selectedOrder.deliveryDate),
      deliveryDateTo: formatDateArg(selectedOrder.deliveryDate),
      itemNumber: selectedOrder.originalItem || selectedOrder.itemNumber || '',
      orderNumber: selectedOrder.orderNumber || '',
      site: selectedOrder.site || selectedOrder.opco || '',
    };
    exportHistoryTrack(payload).catch(() => { });
  };

  //View Details
  // actionColumn: show button only for first or last row on the current page (overall first/last determined from pagination)
  const actionColumn = {
    title: '',
    dataIndex: 'historyId',
    width: 120,
    render: (historyId, record, idx) => {
      const totalRows = pagination.total || 0;
      const pageSize = pagination.pageSize || 1;
      const lastPageIndex = Math.max(1, Math.ceil(totalRows / pageSize));

      const isFirst = pagination.current === 1 && idx === 0;
      const isLast = pagination.current === lastPageIndex && idx === ((auditLogData || []).length - 1);

      if (!isFirst && !isLast) return null;

      return (
        <div>
          <Button size="small" onClick={() => handleViewDetails(record, idx)}>View Detail</Button>
        </div>
      );
    },
  };
  //View Details

  const columns = [
    { title: '#', dataIndex: 'index', width: 60, blankWidth: 60, render: (text, record, idx) => idx + 1 },
    {
      title: 'Original Item',
      dataIndex: 'itemNumber',
      width: 140,
      blankWidth: 140,
      render: val => (val && String(val).trim() ? val : '—'),
    },
    {
      title: 'Original Item Description',
      dataIndex: 'itemDescription',
      width: 220,
      blankWidth: 220,
      render: val => (val && String(val).trim() ? val : '—'),
    },
    {
      title: 'Total Outs',
      dataIndex: 'totalOuts',
      width: 100,
      blankWidth: 100,
      render: val => (val !== undefined && val !== null && String(val).trim() !== '' ? val : '—'),
    },
    {
      // title: 'Old Value',
      title:'Values Before Change',
      dataIndex: 'oldValue',
      width: 140,
      blankWidth: 140,
      render: val => {
        const v = val && String(val).trim();
        return v ? <span className="log-old-value"><s>{v}</s></span> : '—';
      },
    },
    {
      // title: 'New Value',
      title:'Values After Change',
      dataIndex: 'newValue',
      width: 140,
      blankWidth: 140,
      render: val => {
        const v = val && String(val).trim();
        return v ? <span className="log-new-value">{v}</span> : '—';
      },
    },
    {
      title: 'Remarks',
      dataIndex: 'remarks',
      width: 300,
      blankWidth: 300,
      className: 'remarks-column',
      render: val => {
        const remarks = val && String(val).trim();

        return remarks ? (
          <div className="remarks-text">{remarks}</div>
        ) : (
          '—'
        );
      },
    },
    {
      title: 'User ID',
      dataIndex: 'userId',
      width: 140,
      blankWidth: 140,
      render: val => (val && String(val).trim() ? val : '—'),
    },
    {
      // title: 'Action Taken on Manage Out Screen',
      title:'Manage Outs Action Taken',
      dataIndex: 'manageOutsAction',
      width: 240, blankWidth: 240,
      render: v => (v && String(v).trim() ? v : '—')
    },
    {
      // title: 'Is Visible on Manage Out Screen',
      title:'Displayed on Manage Outs?',
      dataIndex: 'visibleOnManageOutScreen',
      width: 240,
      blankWidth: 240,
      render: v => (v === true || v === 'true' ? 'True' : 'False'),
    },
    {
      title: 'Timestamp',
      dataIndex: 'modifiedTimestamp',
      width: 180,
      blankWidth: 180,
      render: (val, record) => {
        const ts = record && (record.modifiedTimestampCst || record.modifiedTimestamp);
        if (!ts) return '—';
        const modifiedDate = moment(ts).format(DATE_TIME_ONE_FORMAT);
        return `${modifiedDate} CST`;
      },
    },

  ];
  columns.push(actionColumn);

  const onLogsTableChange = (page, pageSize) => {
    if (!selectedOrder) return;
    const params = {
      site: selectedOrder.site || selectedOrder.opco || '',
      orderNumber: selectedOrder.orderNumber || selectedOrder.orderNo || '',
      conceptId: selectedOrder.conceptId || '',
      customerShipTo: selectedOrder.customerShipTo || selectedOrder.customerNumber || '',
      deliveryDateFrom: formatDateArg(selectedOrder.deliveryDate),
      deliveryDateTo: formatDateArg(selectedOrder.deliveryDate),
      itemNumber: selectedOrder.originalItem || selectedOrder.itemNumber || '',
      pageIndex: page,
      pageSize,
    };
    fetchAuditTrailLogs(params).then(resp => {
      if (resp) {
        setPagination(prev => ({
          ...prev,
          total: resp.total || 0,
          current: resp.pageIndex || page,
          pageSize: resp.pageSize || pageSize,
        }));
      }
    });
  };

  return (
    <div className="manage-outs-audit-trail-logs">
      <div className="chart-title flex justify-space-between">

        <p className="font-size-16-bold" style={{ margin: 0 }}>
          {selectedOrder ? `↓ Audit Trail Logs — Order #${selectedOrder.orderNumber}` : ' ↓ Audit Trail Logs'}
        </p>

        {/* <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {!isMobile && (
            <div className="export-button">
              <Button type="link" onClick={exportAuditReports} disabled={!auditLogData || auditLogData.length === 0 || exportHistoryTrackPending}>
                Export
              </Button>
            </div>
          )}

          <span className="results-count">
            {pagination.total ? `${pagination.total} row${pagination.total > 1 ? 's' : ''}` : '0 rows'}
          </span>
        </div> */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Button type="link" onClick={() => setAnswerKeyVisible(true)} style={{ padding: 0 }}>
            Answer Key
          </Button>

          {!isMobile && (
            <div className="export-button">
              <Button
                type="link"
                onClick={exportAuditReports}
                disabled={!auditLogData || auditLogData.length === 0 || exportHistoryTrackPending}
              >
                Export
              </Button>
            </div>
          )}

          <span className="results-count">
            {pagination.total ? `${pagination.total} row${pagination.total > 1 ? 's' : ''}` : '0 rows'}
          </span>
        </div>
        <Modal
          title="Answer Key"
          visible={answerKeyVisible}
          onCancel={() => setAnswerKeyVisible(false)}
          footer={null}
          width={900}
        >
          {/* <ul style={{ margin: 0, paddingLeft: 20, lineHeight: '1.8' }}>
            {answerKeyItems.map(item => (
              <li key={item}>{item}</li>
            ))}
          </ul> */}
          {renderAnswerKey()}
        </Modal>
      </div>

      <div className="manage-outs-table-wrap">
        {fetchAuditLogError ? (
          <div style={{ padding: 16 }}>
            <Alert
              message="Error loading audit logs"
              description={fetchAuditLogError}
              type="error"
              showIcon
            />
          </div>
        ) : (
          <Table
            rowKey={record => `${record.historyId || record.modifiedTimestamp || record.itemNumber}`}
            className="dashboard-order-report-table audit-logs common-report-table"
            columns={columns}
            dataSource={auditLogData}
            loading={fetchAuditLogPending}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: pagination.total,
              showSizeChanger: true,
              pageSizeOptions: ['5', '10', '20', '50'],
              onChange: (page, pageSize) => onLogsTableChange(page, pageSize),
              onShowSizeChange: (current, size) => onLogsTableChange(1, size),
            }}
          />
        )}
        {/* View Details */}
        <Modal visible={detailModalVisible}
          onCancel={() => setDetailModalVisible(false)}
          footer={null}
          title="Audit Trail Log Details"
        >
          <div style={{ maxHeight: '60vh', overflow: 'auto' }}>
            {detailLoading ? (
              <div>Loading...</div>
            ) : detailError ? (
              <Alert type="error" message="Error" description={detailError} />
            ) : selectedLog ? (
              <div>
                {/* <p><strong>Type:</strong> {selectedLog.which}</p> */}

                {selectedLog.which === 'both' && selectedLog.value ? (
                  <div style={{ display: 'flex', gap: 24 }}>
                    <div style={{ flex: 1 }}>
                      {renderObjectFields(selectedLog.value.initialValue)}
                    </div>
                    <div style={{ flex: 1 }}>
                      {renderObjectFields(selectedLog.value.currentValue)}
                    </div>
                  </div>
                ) : (
                  renderObjectFields(selectedLog.value)
                )}
              </div>
            ) : 'No details'}
          </div>
        </Modal>
        {/* View Details */}
      </div>
    </div>
  );
}

ManageOutsAuditTrailLogs.propTypes = {};
ManageOutsAuditTrailLogs.defaultProps = {};
